/* eslint-disable */
import moment from 'moment';
import { decryptData, GetCustomerSkipTrace } from '../api/user';
import crypto, { createDecipheriv } from 'crypto';
import { BASIC_INFORMATION_TEMPLATE, CustomerBasicInformation, GetCustomerResponse } from './skipTraceUtilsInterface';

export const PerformSkipTrace = async (
  featureFlagDetails: any,
  customerInfoResponse: any
) => {
  try {
    const approvalResponse =
      customerInfoResponse?.GetApproval?.value?.customerApprovalDetails;
    const customerData = customerInfoResponse?.GetCustomer?.value;

    const basicInformationSkipTrace = await buildBasicInformation(
      customerData,
      true
    );

    const requestLevel = featureFlagDetails?.CustomerSkipTraceRequestLevels;

    // if (!approvalResponse?.verifyLevel) return;

    const skipTraceRequiredCustomerSource: Record<string, number[]> =
      JSON.parse(requestLevel);

    const salesLeadId = customerData?.salesLeadId;
    const verifyCode = approvalResponse?.verifyCode;
    const verifyLevel = approvalResponse?.verifyLevel;
    const isCreatedByECOM = ['EC', 'ECOM'].includes(customerData?.createdBy);

    const customerSource = getCustomerSource(
      salesLeadId,
      isCreatedByECOM,
      verifyCode
    );
    const requiredNumbers =
      skipTraceRequiredCustomerSource[customerSource] || [];

    const payload = {
      customerDetails: [
        {
          customerId: customerData?.customerId,
          firstName: basicInformationSkipTrace?.firstName,
          lastName: basicInformationSkipTrace?.lastName,
          ssn: basicInformationSkipTrace?.ssn,
          dateOfBirth: basicInformationSkipTrace?.dateOfBirth,
          requiredSkipTraceData: {
            phone: 'Y',
            address: 'Y',
            email: 'Y',
            employer: 'Y',
            reference: 'Y',
          },
        },
      ],
    };

    if (requiredNumbers.includes(Number(verifyLevel))) {
      await GetCustomerSkipTrace(payload);
    }
  } catch (error: any) {
    /* eslint-disable no-console */
    console.error('Error in performSkipTrace:', error?.message);
  }
};

const getCustomerSource = (
  salesLeadId: any,
  isCreatedByECOM: boolean,
  verifyCode: string | null
): string => {
  const isCodeNegative = verifyCode === '-1' || verifyCode == null;
  const isCodeZeroOrOne = verifyCode === '0' || verifyCode === '1';

  if ((salesLeadId || isCreatedByECOM) && isCodeNegative) return 'PW';
  if ((salesLeadId || isCreatedByECOM) && isCodeZeroOrOne) return 'NW';
  if (isCodeNegative) return 'PC';
  if (isCodeZeroOrOne) return 'NC';

  return '';
};

const EMPTY_STRING: string = "";
const STRING_YES: string = "Y";
const STRING_NO: string = "N";

export const buildBasicInformation = async (
  basicInformationResponse: GetCustomerResponse,
  featureFlagDetails: boolean
): Promise<CustomerBasicInformation> => {
  try {
    const encryptKey = crypto.randomBytes(16).toString("hex");
    const ivKey = crypto.randomBytes(8).toString("hex");

    const basicInformation: any = {
      ...BASIC_INFORMATION_TEMPLATE,
    };
    basicInformation.firstName =
      basicInformationResponse.firstName || EMPTY_STRING;
    basicInformation.lastName =
      basicInformationResponse.lastName || EMPTY_STRING;
    basicInformation.dateOfBirth =
      moment(basicInformationResponse.dateOfBirth).format("MM/DD/YYYY") ||
      EMPTY_STRING;
    basicInformation.ssn = basicInformationResponse.taxId
      ? basicInformationResponse.taxId
      : EMPTY_STRING;
    basicInformation.emailAddress =
      basicInformationResponse.emailAddress || EMPTY_STRING;
    basicInformation.governmentIdType =
      basicInformationResponse.governmentIdType || EMPTY_STRING;
    basicInformation.governmentId =
      basicInformationResponse.governmentId || EMPTY_STRING;
    basicInformation.governmentIdIssuedState =
      basicInformationResponse.governmentIdIssuedState || EMPTY_STRING;
    basicInformation.salutation =
      basicInformationResponse.salutation || EMPTY_STRING;
    basicInformation.middleInitial =
      basicInformationResponse.middleInitial || EMPTY_STRING;
    basicInformation.suffix = basicInformationResponse.suffix || EMPTY_STRING;
    basicInformation.racCoworker =
      basicInformationResponse.coworker || EMPTY_STRING;
    basicInformation.globalCustomerId =
      basicInformationResponse.globalCustomerId || EMPTY_STRING;
    basicInformation.dateOfBirthEnc =
      basicInformationResponse.dateOfBirthEnc || EMPTY_STRING;
    basicInformation.taxIdEnc =
      basicInformationResponse.taxIdEnc || EMPTY_STRING;
    basicInformation.governmentIdEnc =
      basicInformationResponse.governmentIdEnc || EMPTY_STRING;
    basicInformation.verified =
      basicInformationResponse.verified &&
        basicInformationResponse.verified == STRING_YES
        ? STRING_YES
        : STRING_NO;
    basicInformation.verifiedDate =
      basicInformationResponse.verifiedDate || EMPTY_STRING;
    basicInformation.oktaId = basicInformationResponse.oktaId || EMPTY_STRING;
    basicInformation.isEditEnabled = featureFlagDetails;
    console.log(basicInformation.ssn, "basicInformation.ssn");
    
    const addresses = basicInformationResponse.addresses;
    if (addresses && addresses.length) {
      const primaryAddresses = addresses.find(
        (element: any) => element.addressType == "PRIM"
      );
      basicInformation.addressLine1 = primaryAddresses?.addressLine1
        ? primaryAddresses?.addressLine1
        : EMPTY_STRING;
      basicInformation.addressLine2 = primaryAddresses?.addressLine2
        ? primaryAddresses?.addressLine2
        : EMPTY_STRING;
      basicInformation.zip = primaryAddresses?.postalCode
        ? primaryAddresses?.postalCode
        : EMPTY_STRING;
      basicInformation.city = primaryAddresses?.city
        ? primaryAddresses?.city
        : EMPTY_STRING;
      basicInformation.state = primaryAddresses?.state
        ? primaryAddresses?.state
        : EMPTY_STRING;
    }
    const decrytptedValues: any = await decryptData({
      decryptData: {
        dateOfBirth: basicInformationResponse.dateOfBirthEnc
          ? basicInformationResponse.dateOfBirthEnc
          : undefined,
        taxId: basicInformationResponse.taxIdEnc
          ? basicInformationResponse.taxIdEnc
          : undefined,
        governmentId: basicInformationResponse.governmentIdEnc
          ? basicInformationResponse.governmentIdEnc
          : undefined,
      },
      encryptKey,
      ivKey,
    });

    console.log(decrytptedValues?.decryptData , "decrytptedValues");
    
    if (decrytptedValues?.decryptData) {
      basicInformation.dateOfBirth = decrytptedValues?.decryptData
        ?.dateOfBirth
        ? getData(
          encryptKey,
          ivKey,
          decrytptedValues?.decryptData?.dateOfBirth
        )
        : EMPTY_STRING;
      basicInformation.dateOfBirthDec = decrytptedValues?.decryptData
        ?.dateOfBirth
        ? getData(
          encryptKey,
          ivKey,
          decrytptedValues?.decryptData?.dateOfBirth
        )
        : EMPTY_STRING;
      basicInformation.taxIdDecr = decrytptedValues?.decryptData?.taxId
        ? getData(encryptKey, ivKey, decrytptedValues?.decryptData?.taxId)
        : EMPTY_STRING;
      basicInformation.ssn = decrytptedValues?.decryptData?.taxId
        ? getData(encryptKey, ivKey, decrytptedValues?.decryptData?.taxId)
        : EMPTY_STRING;
      basicInformation.govtIdDecr = decrytptedValues?.decryptData
        ?.governmentId
        ? getData(
          encryptKey,
          ivKey,
          decrytptedValues?.decryptData?.governmentId
        )
        : EMPTY_STRING;
    }
    return basicInformation;
  } catch (error: any) {
    console.log("Error in buildBasicInformation: ", error?.message);
    return { ...BASIC_INFORMATION_TEMPLATE };
  }
};

const getData = (key: string, iv: string, data: string) => {
  const decipher = createDecipheriv("aes-256-cbc", key, iv);
  let result: any = decipher.update(data, "hex", "utf8");
  result += decipher.final("utf8");
  return result;
};
